import SharedSortableTableController from "../../shared/sortable_table_controller";

// Connects to data-controller="administration--apps--sortable-table"
export default class extends SharedSortableTableController {
  getColumnIndex(attribute) {
    const attributeToIndexMap = {
      name: 0,
      author: 1,
      created_at: 2,
    };

    return attributeToIndexMap[attribute] || 0;
  }
}
